import { chileRegions, chileCommunes } from './chileRegions';

export const CONTACT_SOURCE_OPTIONS = [
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'website', label: 'Website' },
  { value: 'feria_evento', label: 'Feria / Evento' },
  { value: 'referido', label: 'Referido' },
  { value: 'visita_comercial', label: 'Visita comercial' },
  { value: 'email', label: 'Email' },
  { value: 'llamada', label: 'Llamada / WhatsApp' },
  { value: 'redes_sociales', label: 'Redes sociales' },
  { value: 'plataforma', label: 'Plataforma' },
  { value: 'cliente_existente', label: 'Cliente existente' },
  { value: 'otros', label: 'Otros' },
];

// Configuración del formulario de organizaciones
export const organizationFormConfig = {
  title: "Organización",
  subtitle: "Complete la información de la organización",
  fields: [
    // Campo especial para "Agregado por" - se mostrará en la parte superior
    {
      name: 'created_by',
      label: 'Agregado por',
      type: 'select',
      placeholder: 'Seleccione el ejecutivo',
      required: true,
      options: [], // Se llenará dinámicamente con usuarios de la tabla A00401
      position: 'top' // Campo especial para mostrar en la parte superior
    },
    // Campos reorganizados según solicitud
    // 1. Nombre - RUT
    {
      name: 'org_name',
      label: 'Nombre',
      type: 'text',
      placeholder: 'Ingrese el nombre de la organización',
      required: true,
      validation: (value) => {
        if (value.length < 2) {
          return 'El nombre debe tener al menos 2 caracteres';
        }
        return true;
      }
    },
    {
      name: 'org_rut',
      label: 'RUT',
      type: 'text',
      placeholder: '12.345.678-9',
      validation: (value) => {
        if (value && !/^\d{1,2}\.\d{3}\.\d{3}-[\dkK]$/.test(value)) {
          return 'Formato de RUT inválido (ej: 12.345.678-9)';
        }
        return true;
      }
    },
    // 2. Fuente - Detalles Fuente
    {
      name: 'source',
      label: 'Fuente',
      type: 'select',
      placeholder: 'Seleccione la fuente',
      required: true,
      options: [
        { value: 'linkedin', label: 'LinkedIn' },
        { value: 'website', label: 'Website' },
        { value: 'feria_evento', label: 'Feria/Evento' },
        { value: 'referido', label: 'Referido' },
        { value: 'visitas', label: 'Visitas' },
        { value: 'plataforma', label: 'Plataforma' },
        { value: 'otros', label: 'Otros' }
      ]
    },
    {
      name: 'source_details',
      label: 'Detalles Fuente',
      type: 'textarea',
      placeholder: 'Ingrese detalles adicionales sobre la fuente',
      rows: 2
    },
    // 3. Segmento - Industria
    {
      name: 'segment',
      label: 'Segmento',
      type: 'select',
      required: true,
      placeholder: 'Seleccione el segmento',
      options: [
        { value: 'B2B', label: 'B2B (Business to Business)' },
        { value: 'B2C', label: 'B2C (Business to Consumer)' },
        { value: 'B2G', label: 'B2G (Business to Government)' },
        { value: 'B2B2C', label: 'B2B2C (Business to Business to Consumer)' },
        { value: 'Sin Asignar', label: 'Sin Asignar' }
      ]
    },
    {
      name: 'industry',
      label: 'Industria',
      type: 'select',
      placeholder: 'Seleccione la industria',
      options: [
        { value: 'Administración Pública', label: 'Administración Pública' },
        { value: 'FFAA', label: 'FFAA' },
        { value: 'Educación', label: 'Educación' },
        { value: 'Salud', label: 'Salud' },
        { value: 'Minería', label: 'Minería' },
        { value: 'Logística', label: 'Logística' },
        { value: 'Energía', label: 'Energía' },
        { value: 'Construcción Naval', label: 'Construcción Naval' },
        { value: 'Alimentos', label: 'Alimentos' },
        { value: 'Construcción', label: 'Construcción' },
        { value: 'Turismo', label: 'Turismo' },
        { value: 'Montaje y Mantención', label: 'Montaje y Mantención' },
        { value: 'OEM', label: 'OEM' },
        { value: 'Modulares', label: 'Modulares' },
      ]
    },
    // 4. Canal - Plataforma
    {
      name: 'channel',
      label: 'Canal',
      type: 'select',
      placeholder: 'Seleccione el canal',
      options: [
        { value: 'Directo', label: 'Directo' },
        { value: 'M. Público - Compra Ágil', label: 'M. Público - Compra Ágil' },
        { value: 'M. Público - Licitación', label: 'M. Público - Licitación' },
        { value: 'M. Público - Trato Directo', label: 'M. Público - Trato Directo' },
        { value: 'Senegocia', label: 'Senegocia' },
        { value: 'WhereX', label: 'WhereX' },
      ]
    },
    {
      name: 'platform',
      label: 'Plataforma',
      type: 'select',
      placeholder: 'Seleccione la plataforma',
      options: [
        { value: 'Mercado Público', label: 'Mercado Público' },
        { value: 'WhereX', label: 'WhereX' },
        { value: 'SeNegocia', label: 'SeNegocia' }
      ]
    },
    // 5. Web - LinkedIn
    {
      name: 'website',
      label: 'Web',
      type: 'url',
      prefix: 'http://',
      placeholder: 'www.ejemplo.com'
    },
    {
      name: 'linkedin',
      label: 'LinkedIn',
      type: 'url',
      prefix: 'http://',
      placeholder: 'linkedin.com/company/empresa'
    },
    // 6. Tamaño - Condición de Pago
    {
      name: 'size',
      label: 'Tamaño',
      type: 'select',
      placeholder: 'Seleccione el tamaño',
      options: [
        { value: '1-10', label: '1-10 empleados' },
        { value: '11-50', label: '11-50 empleados' },
        { value: '51-200', label: '51-200 empleados' },
        { value: '201-500', label: '201-500 empleados' },
        { value: '501-1000', label: '501-1000 empleados' },
        { value: '1000+', label: '1000+ empleados' }
      ]
    },
    {
      name: 'payment_conditions',
      label: 'Condición de Pago',
      type: 'select',
      placeholder: 'Seleccione las condiciones',
      options: [
        { value: 'contado', label: 'Contado' },
        { value: '30_dias', label: '30 días' },
        { value: '60_dias', label: '60 días' },
        { value: 'anticipo', label: 'Anticipo' },
        { value: 'otro', label: 'Otro' }
      ]
    },
    // 7. Giro Facturación - Notas
    {
      name: 'billing_business_line',
      label: 'Giro Facturación',
      type: 'text',
      placeholder: 'Ingrese el giro comercial'
    },
    {
      name: 'notes',
      label: 'Notas',
      type: 'textarea',
      placeholder: 'Notas adicionales sobre la organización',
      rows: 3
    },
    // 8. Dirección Principal (3 campos en la misma fila)
    {
      name: 'main_region',
      label: 'Región Principal',
      type: 'select',
      placeholder: 'Seleccione la región',
      options: chileRegions,
      onChange: 'updateMainCommunes',
      group: 'main_address_group'
    },
    {
      name: 'main_county',
      label: 'Comuna Principal',
      type: 'select',
      placeholder: 'Seleccione la comuna',
      options: [],
      dependsOn: 'main_region',
      group: 'main_address_group'
    },
    {
      name: 'main_address',
      label: 'Dirección Principal',
      type: 'text',
      placeholder: 'Ingrese la dirección principal',
      group: 'main_address_group'
    },
    // 9. Dirección Envío (3 campos en la misma fila)
    {
      name: 'delivery_region',
      label: 'Región Envío',
      type: 'select',
      placeholder: 'Seleccione la región',
      options: chileRegions,
      onChange: 'updateDeliveryCommunes',
      group: 'delivery_address_group'
    },
    {
      name: 'delivery_county',
      label: 'Comuna Envío',
      type: 'select',
      placeholder: 'Seleccione la comuna',
      options: [],
      dependsOn: 'delivery_region',
      group: 'delivery_address_group'
    },
    {
      name: 'delivery_address',
      label: 'Dirección Envío',
      type: 'text',
      placeholder: 'Ingrese la dirección de envío',
      group: 'delivery_address_group'
    },
    // 10. Dirección Facturación (3 campos en la misma fila)
    {
      name: 'billing_region',
      label: 'Región Facturación',
      type: 'select',
      placeholder: 'Seleccione la región',
      options: chileRegions,
      onChange: 'updateBillingCommunes',
      group: 'billing_address_group'
    },
    {
      name: 'billing_county',
      label: 'Comuna Facturación',
      type: 'select',
      placeholder: 'Seleccione la comuna',
      options: [],
      dependsOn: 'billing_region',
      group: 'billing_address_group'
    },
    {
      name: 'billing_address',
      label: 'Dirección Facturación',
      type: 'text',
      placeholder: 'Ingrese la dirección de facturación',
      group: 'billing_address_group'
    }
  ]
};

// Configuración del formulario de contactos
export const contactFormConfig = {
  title: "Contacto",
  subtitle: "Complete la información del contacto",
  fields: [
    {
      name: 'contact_name',
      label: 'Nombre Completo',
      type: 'text',
      placeholder: 'Ingrese el nombre completo del contacto',
      required: true,
      validation: (value) => {
        if (value.length < 2) {
          return 'El nombre debe tener al menos 2 caracteres';
        }
        return true;
      }
    },
    {
      name: 'organization_id',
      label: 'Organización',
      type: 'searchable-select',
      placeholder: 'Buscar organización...',
      required: false,
      options: [] // Se llenará dinámicamente con las organizaciones disponibles
    },
    {
      name: 'position',
      label: 'Cargo',
      type: 'text',
      placeholder: 'Ingrese el cargo del contacto'
    },
    {
      name: 'department',
      label: 'Departamento',
      type: 'text',
      placeholder: 'Ingrese el departamento'
    },
    {
      name: 'mobile',
      label: 'Móvil',
      type: 'tel',
      placeholder: '+56 9 3946 6150'
    },
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'contacto@empresa.com',
      required: false
    },
    {
      name: 'linkedin',
      label: 'LinkedIn',
      type: 'url',
      placeholder: 'https://linkedin.com/in/usuario',
      required: false
    },
    {
      name: 'is_primary',
      label: 'Contacto Principal',
      type: 'checkbox',
      defaultValue: false
    },
    {
      name: 'is_decision_maker',
      label: 'Tomador de Decisiones',
      type: 'checkbox',
      defaultValue: false
    },
    {
      name: 'notes',
      label: 'Notas',
      type: 'textarea',
      placeholder: 'Notas adicionales sobre el contacto',
      rows: 3
    }
  ]
};
